import React from "react";
import "./service.css";
import { Link } from "react-router-dom";
const Service = () => {
  return (
    <div id="service">
      <h3 className="text-center tit">الخدمات</h3>
      <div className="service-container">
        <Link
          to="/user/services/car"
          style={{ textDecoration: "none", color: "#000" }}
        >
          <div className="srvice-item">
            <i className="fa-solid fa-car"></i>
            <h4>خدمات السيارات</h4>
          </div>
        </Link>
        <Link
          to="/user/touristserv"
          style={{ textDecoration: "none", color: "#000" }}
        >
          <div className="srvice-item">
            <i className="fa-solid fa-plane-departure"></i>
            <h4>السياحة</h4>
          </div>
        </Link>
        <Link
          to="/user/trafficserv"
          style={{ textDecoration: "none", color: "#000" }}
        >
          <div className="srvice-item">
            <i className="fa-solid fa-traffic-light"></i>
            <h4>خدمات المرور</h4>
          </div>
        </Link>
        {/* <Link
          to="/user/trafficserv"
          style={{ textDecoration: "none", color: "#000" }}
        >
          <div className="srvice-item">
          <i className="fa-solid fa-award"></i>
            <h4>خدمات التوثيق</h4>
          </div>
        </Link> */}
        <Link 
          to="/user/localserv"
          style={{ textDecoration: "none", color: "#000" }}
        >
          <div className="srvice-item">
            <i className="fa-solid fa-location-pin-lock"></i>
            <h4>خدمات المحليات</h4>
          </div>
        </Link>
        <Link to="/user/takhlesserv" style={{textDecoration:"none",color:"#000"}}>
        <div className="srvice-item">
        <i className="fa-solid fa-handshake"></i>
          <h4>تخليص معاملات</h4>
        </div>
        </Link>

        {/* <Link to="bonqserviece" style={{textDecoration:"none",color:"#000"}}>
        <div className="srvice-item">
        <i className="fa-solid fa-hand-holding-dollar"></i>
          <h4>البنوك</h4>
        </div>
        </Link>
     */}
        <Link
          to="/user/realstatementserv"
          style={{ textDecoration: "none", color: "#000" }}
        >
          <div className="srvice-item">
            <i className="fa-solid fa-briefcase"></i>
            <h4>الشهر العقاري</h4>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Service;
